import { FC } from 'react';

import classNames from 'classnames';

import { Product } from '@/types';

interface IProductDescriptionProps {
  product: Product;
}

const ProductDescription: FC<IProductDescriptionProps> = ({ product }) => {
  const description = product?.description;

  if (!description) return null;

  return (
    <>
      <p className={classNames('details__h3')}>Product descriptions</p>
      <pre
        className="details__description"
        dangerouslySetInnerHTML={{
          __html: description.replace(/\\n/g, '\n'),
        }}
      />
    </>
  );
};

export { ProductDescription };
